import React from "react";
import Login from "../components/auth/login";

const Signin = () => {
  return <Login />;
};

export default Signin;
